module.exports = __webpack_public_path__ + "img/_1.d609241c.png";